<template>
  <vxe-grid
    v-bind="gridOptions"
    :data="viewTableData"
    :columns="tableColumns"
    :span-method="mergeRowMethod"
  >
  </vxe-grid>
</template>
<script>
import { request } from '@/api/service'
import tableColumns from './table-columns'
import dayjs from '@/libs/util.date'
export default {
  props: {
    orderCode: String,
  },
  data() {
    return {
      gridOptions: {
        border: 'full',
        size: 'mini',
        toolbarConfig: {
          zoom: true,
        },
        seqConfig: {
          seqMethod: (params) => this.seqMethod(params),
        },
      },
      tableData: [],
    }
  },
  computed: {
    tableColumns() {
      const baseColumns = tableColumns(this)
      if (!this.tableData.length) return baseColumns

      //生成新的日期表头
      const times = this.tableData
        .map((i) => i.inspectionTime)
        .filter((e, i, t) => t.indexOf(e) === i)
        .map((i) => new Date(dayjs(i)))
        .sort((i, j) => i - j)
        .map((i) => dayjs(i).format('YYYY-MM-DD'))

      const columnGroup = times.map((val) => this.generateGroupColumn(val))
      baseColumns.push(...columnGroup)
      return baseColumns
    },
    viewTableData() {
      const tableData = this.tableData
      if (!tableData || !tableData.length) return []

      const newTableData = tableData.reduce((result, item) => {
        const key = `${item.orderBatchNo}-${item.orderInspectionCode}`
        if (!result[key]) {
          result[key] = item
        }
        result[key][item.inspectionTime] = { ...item }
        return result
      }, {})
      return Object.values(newTableData)
    },
    mergeCellByKey() {
      const mergeByKey = this.tableColumns.find((c) => c.mergeByKey)
      return mergeByKey ? mergeByKey.field : ''
    },
    mergeCell() {
      return this.tableColumns.filter((c) => c.merge).map((c) => c.field)
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      request({
        url: '/factory/order/inspection/listByGoods',
        method: 'post',
        data: {
          orderCode: this.orderCode,
        },
      }).then((res) => {
        this.tableData = res.body.data
      })
    },
    // 通用行合并函数（将相同多列数据合并为一行）
    mergeRowMethod({ row, _rowIndex, column, visibleData }) {
      if (!this.mergeCellByKey) {
        return { rowspan: 1, colspan: 1 }
      }
      const fields = this.mergeCell
      const cellValue = row[this.mergeCellByKey]

      if (fields.includes(column.property)) {
        const prevRow = visibleData[_rowIndex - 1]
        let nextRow = visibleData[_rowIndex + 1]
        if (prevRow && prevRow[this.mergeCellByKey] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[this.mergeCellByKey] === cellValue) {
            nextRow = visibleData[++countRowspan + _rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    generateGroupColumn(field) {
      const groupColumn = {
        title: field,
        align: 'center',
        children: [
          {
            title: this.$l('INDEX.table_label_inspectionType') || '验货方式',
            field: `${field}.v_inspectionType`,
            width: 150,
            align: 'center',
          },
          {
            title:
              this.$l('INDEX.order_tab_inspection_requirements') || '验货要求',
            field: `${field}.inspectionRequirement`,
            width: 200,
            align: 'left',
            headerAlign: 'center',
            showHeaderOverflow: true,
            showOverflow: true,
          },
          {
            title:
              this.$l('INDEX.table_label_orderInspectionStatus') || '处理状态',
            field: `${field}.v_orderInspectionStatus`,
            width: 150,
            align: 'center',
          },
        ],
      }
      return groupColumn
    },
    seqMethod(params) {
      const { row, visibleData } = params
      let group = []
      visibleData.forEach((i) => {
        if (group.indexOf(i.orderBatchNo) < 0) {
          group.push(i.orderBatchNo)
        }
      })
      return group.indexOf(row.orderBatchNo) + 1
    },
  },
}
</script>
